import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

/*
  Generated class for the TranslationProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TranslationProvider {
	browserLanguage: string = "";
	constructor(public http: HttpClient) {
		this.browserLanguage = navigator.language.toLowerCase();
	}

	getLanguageName() {
		if (this.browserLanguage.startsWith("pt")) {
			return "PT";
		}
		else if (this.browserLanguage.startsWith("es")) {
			return "ES";
		}
		else {
			return "";
		}
	}

	getDefaultLang() {
		return "en";
	}

	getCurrentLang() {
		if (this.browserLanguage.startsWith("pt")) {
			return "pt-br";
		}
		else if (this.browserLanguage.startsWith("es")) {
			return "es";
		}
		else {
			return "en"
		}
	}
}
